export enum FileLimitationEnum {
  DenyFileDownload = 'DenyFileDownload',
  DenyFileDownloadEncrypted = 'DenyFileDownloadEncrypted',
  DenyFileShare = 'DenyFileShare',
  DenyFileRename = 'DenyFileRename',
  DenyFileTags = 'DenyFileTags',
  DenyFileAddToFavorites = 'DenyFileAddToFavorites',
  DenyFileHide = 'DenyFileHide',
  DenyFileDelete = 'DenyFileDelete',
  DenyFileDeletePermanently = 'DenyFileDeletePermanently',
  DenyFileRestoreFromTrash = 'DenyFileRestoreFromTrash',
  DenyFileMove = 'DenyFileMove',
  DenyFileReplace = 'DenyFileReplace',
  DenyFileEditDescription = 'DenyFileEditDescription',
  DenyFileEditContent = 'DenyFileEditContent',
  DenyFileSale = 'DenyFileSale',
  DenyFileCreateCopy = 'DenyFileCreateCopy',
  DenyFileCreateShortCut = 'DenyFileCreateShortCut',
  DenyFileFileActivities = 'DenyFileFileActivities',
  DenyFileVersioning = 'DenyFileVersioning',
  DenyFileScreenCapture = 'DenyFileScreenCapture',
  DenyFileOpen = 'DenyFileOpen',
  DenyFileDetails = 'DenyFileDetails',
  DenyFileOpenFileLocation = 'DenyFileOpenFileLocation',
  DenyFileUnHide = 'DenyFileUnHide',
  DenyFileRemoveFromFavorites = 'DenyFileRemoveFromFavorites',
  DenyFileAIClassification = 'DenyFileAIClassification',
  DenyFileAISummary = 'DenyFileAISummary',
  DenyFileAIChat = 'DenyFileAIChat',
  DenyFileAiScraping = 'DenyFileAiScraping',
}
